import * as React from 'react';
import * as styles from './styles.css';
import { IconTriangle } from '../icons';
export function IncDec(_ref) {
  var trend = _ref.trend;

  if (trend === 'none') {
    return null;
  }

  return React.createElement("span", {
    className: styles[trend]
  }, React.createElement(IconTriangle, null));
}